import { jsonMember, jsonObject } from 'typedjson';
import { Guid } from '@web/utils';

@jsonObject
export class AdminOrderShipmentItemRequest {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(Number)
  public readonly quantity!: number;

  public constructor(
    private readonly data: {
      id: Guid;
      quantity: number;
    },
  ) {
    this.id = this.data.id;
    this.quantity = this.data.quantity;
  }
}
